// dev_lp — "Learn how it works" video section. Same YouTube embed as the original.
import React from "react";
import { useTranslation } from "react-i18next";
import SectionHeading from "../components/SectionHeading";

const VideoSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="max-w-4xl mx-auto px-4 sm:px-6 mt-4 mb-20">
      <SectionHeading className="mb-8">{t("video.title")}</SectionHeading>
      <div
        className="relative rounded-3xl overflow-hidden shadow-2xl shadow-blue-900/20 ring-1 ring-white/50"
        style={{ paddingBottom: "56.25%" }}
      >
        <iframe
          className="absolute inset-0 w-full h-full"
          src="https://www.youtube.com/embed/iTzjrudzJg8"
          title={t("video.iframeTitle")}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </section>
  );
};

export default VideoSection;
